import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static classes = ['scaleBox'];

  static targets = ['scaleContainer'];

  static values = { scaleLevel: Number };

  connect() {
    this.renderLikertLevels();
  }

  switchScaleLevel = (event) => {
    this.scaleLevelValue = event.currentTarget.value;
    this.renderLikertLevels();
  };

  renderLikertLevels() {
    this.scaleContainerTarget.innerHTML = '';
    const maxBoxes = Math.min(this.scaleLevelValue, 10);

    for (let i = 1; i <= maxBoxes; i += 1) {
      const box = document.createElement('div');
      box.classList.add(...this.scaleBoxClasses);
      box.innerText = i;
      this.scaleContainerTarget.appendChild(box);
    }
  }
}
